<template>
	<div class="flex w-full justify-end gap-4">
		<depots-dropdown
			v-model="depot"
			:disabled="!items || items.length == 0"
			size="large"
			all-depots
			@update:model-value="emitDepot" />

		<app-button :disabled="!items || items.length == 0" @click="emit('save')">
			Save Changes
		</app-button>

		<app-button :disabled="!depot || !items || items.length == 0" @click="send">
			Send to Yard
		</app-button>
	</div>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import ContractService from '@/services/contract'
	import DepotsDropdown from '../dropdowns/DepotsDropdown.vue'
	import useToasterStore from '@/stores/toaster'
	import type { ContractItem } from '@/data/schema/contract-item'

	const depot = ref('')
	const api = new ContractService()
	const toaster = useToasterStore()

	const props = defineProps({
		items: {
			type: Array<ContractItem>,
			default: []
		},
		changed: {
			type: Boolean,
			default: false
		}
	})

	function emitDepot(selectedDepot: string) {
		depot.value = selectedDepot
		emit('depotSelected', selectedDepot)
	}

	async function send() {
		if (props.items) {
			let items: ContractItem[] = props.items
			items = items.map((obj) => ({
				...obj,
				depot: depot.value,
				status: 1
			}))

			toaster.working({
				text: 'Sending items to yard...',
				timeout: 0,
				dismissable: false
			})

			await api
				.sendItemsToYard(items)
				.then(() => {
					toaster.clear()
					toaster.success({
						text: 'Items sent successfully!'
					})

					emit('sent')
				})
				.catch((error) => {
					console.error(error)
					toaster.clear()
					toaster.error({
						text: 'An error occurred sending items to yard',
						timeout: 0
					})
				})
		}
	}

	const emit = defineEmits(['sent', 'save', 'depotSelected'])
</script>
